import { combineReducers } from 'redux';
import { reducer as tab } from './App';
import { reducer as profiles } from './Profiles';
import { reducer as stories } from './Stories';

/**
 * Main reducer.
 * Consist from next reducers: app, profiles and stories
 */
export default combineReducers({
    tab,
    profiles,
    stories,
});



// WEBPACK FOOTER //
// ./src/js/rootReducer.js